import React, { useState, useEffect } from "react";
import { useStore } from "../../../store/useStore";
import useIntersectionObserver from "../../../hooks/useIntersectionObserver";
import { END_OF_RESPONSE } from "../../../services/RecentActivity/recentTransactions/recentTransaction.constants";
import Spinner from "../../Spinner/spinner";
import { formatTime } from "../../../utils/helperFunctions";
import parse from "html-react-parser";
import { chevronRight } from "../../../assets/images/icons";
import "./orders.scss";
import OrderItemMobile from "./orderItemMobile";
import {
  CHATBOT_SOURCE,
  EVENTS,
  RECENT_ACTIVITY_TYPES,
} from "../../../utils/constants";
import { getPlatformForBot } from "../../Chatbot/ChatbotUtil";
import {
  API_VS_UI_PRODUCT_TYPES_MAPPING,
  ORDER_STATUS_CLASSNAMES,
  ORDER_STATUS_TO_UI_MAPPING,
} from "./orders.constants";
import {
  getMobileOperatingSystem,
  ingestData,
  isMobile,
  navigateToURL,
} from "../../../bridges/BridgeServices";
import FullPagePopover from "../../FullPagePopover/FullPagePopover";

const OrdersMobile = ({ refetchData }) => {
  const [showOrderSheet, setShowOrderSheet] = useState(
    false
  );
  const orders = useStore(state => state.orders);

  const [items, setItems] = useState(orders);
  const nextPageToken = useStore(
    state => state.ordersNextPageToken
  );
  const loading = useStore(state => state.ordersLoading);

  const targetRef = useIntersectionObserver(
    () => {
      if (nextPageToken !== END_OF_RESPONSE) {
        refetchData();
      }
    },
    { threshold: 0.1 }
  );

  useEffect(() => {
    if (showOrderSheet) {
      ingestData({
        name: EVENTS.HELP_ACTIVITY_POPUP_LOADED,
        data: {
          source: isMobile()
            ? getMobileOperatingSystem()
            : "WEB",
          type: RECENT_ACTIVITY_TYPES.ORDERS,
        },
      });
    }
  }, [showOrderSheet]);

  if (orders.length === 0) return <></>;

  const handleOrderClick = (
    order,
    fromBottomSheet = true
  ) => {
    ingestData({
      name: fromBottomSheet
        ? EVENTS.HELP_ACTIVITY_POPUP_CLICKED
        : EVENTS.HELP_ACTIVITY_CLICKED,
      data: {
        source: isMobile()
          ? getMobileOperatingSystem()
          : "WEB",
        type: RECENT_ACTIVITY_TYPES.ORDERS,
        txnId: order?.orderId,
      },
    });
    if (order.orderId) {
      navigateToURL("CHATBOT", {
        src: CHATBOT_SOURCE.ORDERS,
        txnId: order.orderId,
        txnState:
          ORDER_STATUS_CLASSNAMES[
            ORDER_STATUS_TO_UI_MAPPING[order.orderStatus]
          ],
        errorCode: order?.rejectionInfo?.rejectionCode,
        platform: getPlatformForBot(),
      });
    }
  };

  return (
    <div>
      <p className="orderComponent">Orders</p>
      <div>
        {orders?.slice(0, 2).map((item, index) => {
          return (
            <div
              key={index}
              className="lineItem"
              onClick={() => handleOrderClick(item, false)}
            >
              <div className="leftLineItem">
                <div className="typeContainer">
                  <p className="entityType">
                    {item?.instrumentDetails?.name}
                  </p>
                  <p className="inactiveText">
                    {`${
                      API_VS_UI_PRODUCT_TYPES_MAPPING[
                        item.productType
                      ]
                    } • Q - ${item.quantity}`}
                  </p>
                </div>
                <div className="statusContainer">
                  <p
                    className={`paymentState ${
                      ORDER_STATUS_CLASSNAMES[
                        ORDER_STATUS_TO_UI_MAPPING[
                          item.orderStatus
                        ]
                      ]
                    }`}
                  >
                    {
                      ORDER_STATUS_TO_UI_MAPPING[
                        item.orderStatus
                      ]
                    }
                  </p>
                  <p className="inactiveText">
                    {formatTime(item?.createdAt)}
                  </p>
                </div>
              </div>
              <div>{parse(chevronRight)}</div>
            </div>
          );
        })}
      </div>
      <button
        className="actionButton"
        onClick={() => {
          ingestData({
            name: EVENTS.HELP_ACTIVITY_CTA_CLICKED,
            data: {
              source: isMobile()
                ? getMobileOperatingSystem()
                : "WEB",
              type: RECENT_ACTIVITY_TYPES.ORDERS,
            },
          });
          setShowOrderSheet(true);
        }}
      >
        View More Orders
      </button>

      <FullPagePopover
        setIsOpen={setShowOrderSheet}
        isOpen={showOrderSheet}
        title={`Select Order`}
      >
        {orders.map((item, index) => {
          return (
            <OrderItemMobile
              order={item}
              onClick={() => handleOrderClick(item)}
            />
          );
        })}
        {loading ? (
          <Spinner />
        ) : (
          <div
            ref={targetRef}
            style={{ padding: "4px", height: "10px" }}
          ></div>
        )}
      </FullPagePopover>
    </div>
  );
};

export default OrdersMobile;
